import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

// DS
import { VertContainer, VertTabs, VertButton, VertCarousel, Row } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/LikePlus/LikePlusMenuStyles.less';

// LIKE PLUS MENU COMPONENT
const LikePlusMenu = ({ tabItems, handleTab, hasCard }) => {
    /* States */
    const [currentTabContent, setCurrentTabContent] = useState(hasCard ? tabItems[1] : tabItems[0]);

    /* Handlers */
    const mobileTabHandler = (key) => {
        const item = tabItems.find(item => item.key === key);
        setCurrentTabContent(item);
        handleTab(key);
    };

    /* Utils */
    const renderedDesktopMenu = (
        <VertContainer className='like-plus-menu padding-x-regular padding-y-regular'>
            <VertTabs items={tabItems} onTabClick={(key) => handleTab(key)} defaultActiveKey={hasCard ? '2' : '1'} />
        </VertContainer>
    );

    const renderedMobileMenu = tabItems.map((item, index) => (
        <VertButton
            key={`menu-button-${index}`}
            className={`${currentTabContent.key === item.key && 'button-active'}`}
            onClick={() => mobileTabHandler(item.key)}
        >
            {item.label}
        </VertButton>
    ));

    /* Renders */
    return (
        <>
            {/* Desktop */}
            <MediaQuery minWidth={769}>
                {renderedDesktopMenu}
            </MediaQuery>

            {/* Mobile */}
            <MediaQuery maxWidth={768}>
                <Row className='like-plus-menu padding-y-small'>
                    <VertCarousel
                        dots={false}
                        slidesToShow={3}
                        slidesToScroll={1}
                        variableWidth
                        centerPadding="6px"
                        responsive={
                            [

                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        arrows: true,
                                    },
                                },
                                {
                                    breakpoint: 576,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        arrows: true,
                                    },
                                },
                                {
                                    breakpoint: 280,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    },
                                },
                            ]}
                    >
                        {renderedMobileMenu}
                    </VertCarousel>
                </Row>
                {currentTabContent.children}
            </MediaQuery>
        </>
    );
};
LikePlusMenu.propTypes = {
    tabItems: PropTypes.array.isRequired,
    handleTab: PropTypes.func.isRequired
};

export default LikePlusMenu;
